export const ReduxContentFooterProp = 'footer';
